import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { Modal } from '../../../components/mplat/Modal';
import { useCreateTranscodeTaskMutation } from '../../../services/transcode';
import { TranscodeModalProps } from '../types';

export function TranscodeModal({ isOpen, onClose, mediaUrls, profileId }: TranscodeModalProps) {
    const [createTranscode] = useCreateTranscodeTaskMutation();
    const [success, setSuccess] = useState<boolean>();
    const [fail, setFail] = useState<string>();
    const successClass = 'popup_message';

    useEffect(() => {
        if (isOpen) {
            setSuccess(false);
        }
    }, [isOpen]);

    return (
        <Modal className={success ? successClass : 'form-opinion'} isOpen={isOpen} onClose={() => onClose()}>
            {success ?
                <div className="form-message _success">
                    <div className="form-message__icon"></div>
                    <h2 className="popup__heading form-message__heading">Спасибо за&nbsp;ваши предложения</h2>
                    <div className="form-message__copy">
                        Мы&nbsp;обязательно примем их&nbsp;к&nbsp;рассмотрению
                    </div>
                    <div className="form-message__ok">
                        <span className="btn" onClick={() => onClose()}>Хорошо</span>
                    </div>
                </div>
                :
                ((fail || mediaUrls.length === 0)
                    ?
                    <div className="form-message _error">
                        <div className="form-message__icon"></div>
                        <h2 className="popup__heading form-message__heading">
                            {mediaUrls.length === 0 ?
                                'Отсутствуют медиа файлы'
                                :
                                'Что-то пошло не так'
                            }
                        </h2>
                        <div className="form-message__copy">
                            {fail}
                            {mediaUrls.length === 0 &&
                                <>Для транскодирования загрузите файлы контента</>
                            }
                        </div>
                        <div className="form-message__ok">
                            <span className="btn" onClick={() => onClose()}>Понятно</span>
                        </div>
                    </div>
                    :
                    <div className="transcode-order">
                        <div className="transcode-order__heading">Заказ транскодирования</div>
                        <div className="transcode-order__settings">
                            <div className="transcode-order__settings-item">
                                Контейнер <strong>HLS</strong>
                            </div>
                            <div className="transcode-order__settings-sep"></div>
                            <div className="transcode-order__settings-item">
                                <Trans>Video codec</Trans> <strong>H.264</strong>
                            </div>
                            <div className="transcode-order__settings-sep"></div>
                            <div className="transcode-order__settings-item">
                                Аудиокодек <strong>AAC</strong>
                            </div>
                        </div>
                        <ul className="transcode-order__formats">
                            <li>416×234 · <strong>145</strong> kbps</li>
                            <li>640×360 · <strong>365</strong> kbps</li>
                            <li>768×432 · <strong>730</strong> kbps</li>
                            <li>1280×720 · <strong>3</strong> Mbps</li>
                            <li>1920×1080 · <strong>6</strong> Mbps</li>
                        </ul>
                        <div className="transcode-order__submit">
                            <span
                                className="btn"
                                onClick={() => {
                                    mediaUrls.map(mediaUrl =>
                                        createTranscode({ profileId: profileId, mediaUrl: mediaUrl }).unwrap().then(() => {
                                            onClose();
                                        }).catch(e => {
                                            setFail(JSON.stringify(e));
                                        })
                                    );
                                }}
                            >
                                Подтвердить заказ
                            </span>
                        </div>
                    </div>
                )
            }
        </Modal >
    );
}